/**
 * @returns {*}
 */
function email () {
  return /^[a-zA-Z0-9\u007F-\uffff!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9\u007F-\uffff!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z]{2,}$/
}

module.exports = { email }
